import React from 'react'
import { withIcon } from '../../withIcon'

function EllipsisVerticalIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.625 19C11.625 19.2071 11.7929 19.375 12 19.375C12.2071 19.375 12.375 19.2071 12.375 19C12.375 18.7929 12.2071 18.625 12 18.625C11.7929 18.625 11.625 18.7929 11.625 19ZM12 20.625C11.1025 20.625 10.375 19.8975 10.375 19C10.375 18.1025 11.1025 17.375 12 17.375C12.8975 17.375 13.625 18.1025 13.625 19C13.625 19.8975 12.8975 20.625 12 20.625ZM11.625 12C11.625 12.2071 11.7929 12.375 12 12.375C12.2071 12.375 12.375 12.2071 12.375 12C12.375 11.7929 12.2071 11.625 12 11.625C11.7929 11.625 11.625 11.7929 11.625 12ZM12 13.625C11.1025 13.625 10.375 12.8975 10.375 12C10.375 11.1025 11.1025 10.375 12 10.375C12.8975 10.375 13.625 11.1025 13.625 12C13.625 12.8975 12.8975 13.625 12 13.625ZM11.625 5C11.625 5.20711 11.7929 5.375 12 5.375C12.2071 5.375 12.375 5.20711 12.375 5C12.375 4.79289 12.2071 4.625 12 4.625C11.7929 4.625 11.625 4.79289 11.625 5ZM12 6.625C11.1025 6.625 10.375 5.89746 10.375 5C10.375 4.10254 11.1025 3.375 12 3.375C12.8975 3.375 13.625 4.10254 13.625 5C13.625 5.89746 12.8975 6.625 12 6.625Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EllipsisVerticalIcon)
